// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Typography from "@insite/mobius/Typography";
import injectCss from "@insite/mobius/utilities/injectCss";
import color from "@steiner/XDL/Utilities/color";
import styled, { css, CSSProperties } from "styled-components";

type DividerProps = {
    direction?: "vertical" | "horizontal";
    margin?: CSSProperties["margin"];
    borderColor?: string;
    printDisplay?: string;
};

export const Divider = styled.div<DividerProps>`
    background-color: ${({ borderColor }: any) =>
        css`
            ${color(borderColor || "common.border")};
        `};
    align-self: stretch;
    ${({ printDisplay }: any) => `@media print {display: ${printDisplay}}`}
    ${({ direction, margin }: any) =>
        direction === "vertical"
            ? `
                min-height: 100%;
                height: auto;
                width: 1px;
                min-width: 1px;
                margin: ${margin || `0 12px`};
                `
            : `
                width: 100%; 
                height: 1px;
                margin: ${margin || `12px 0`};
        `}
`;

export const StyledHr = styled(Typography).attrs({ as: "hr" })`
    width: 100%;
    border: none;
    border-bottom: 1px solid ${color("common.border")};
    margin: 0;

    ${injectCss}
`;
